import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { TabContext } from '@mui/lab';

import StyledTabs from '../../../styled/Tabs';
import StyledTab from '../../../styled/Tab';
import StyledTabPanel from '../../../styled/TabPanel';

import apiClient from '../../../../services/api';
import store from '../../../../store';
import { toggleMessageOpen } from '../../../../store/actions/Message';
import Report from './tabs/Report';
import ElementInfo from '../../easyBoardOnline/view/ElementInfo';

function ScannedProjectLeftSidePanel()
{
    const { id } = useParams();
    const { t } = useTranslation();
    
    const [products, setProducts] = useState([])
    const [selectedTab, setSelectedTab] = useState('report');

    useEffect(() => {
        apiClient.post('/api/scanned-projects/load-products', { id: Number(id) }).then((response) => {
            if (!response.data.success) {
                return;
            }

            setProducts(response.data.products);
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while loading report'), "error"))
        })
    }, []);
    
    const handleChangeTab = (event, newTab) => { setSelectedTab(newTab) };

    return [
        <ElementInfo type="scanned-projects" />,
        <TabContext value={selectedTab}>
            <StyledTabs
                value={selectedTab}
                onChange={handleChangeTab}
                textColor="inherit"
                variant="fullWidth"
            >
                <StyledTab label={t('Report')} value="report" />
            </StyledTabs>
            
            <StyledTabPanel value="report">
                <Report elements={products} />
            </StyledTabPanel>
        </TabContext>
    ];
}

export default ScannedProjectLeftSidePanel;
